import ID from './ID'

export enum TagType {
  MarketingObjectives = 'Marketing Objectives',
  TargetAudience = 'Target Audience',
  Custom = 'Custom',
}

export default class Tag {
  public editing = false
  public editingValues: any

  constructor(
    public id: ID = new ID(),
    public text: string = '',
    public planId: ID = new ID(),
    public isLead: boolean = false,
    public isNested: boolean = false,
    public orderIndex: number = 0,

    public abbreviatedPlanName: string = ''
  ) {
    this.editingValues = {
      name: this.title,
      isLead: this.isLead,
      isNested: this.isNested,
    }
  }

  public get key() {
    return 'tag-' + this.id.intID.toString()
  }

  public get type(): string {
    return this.text?.split(':')?.[0]
  }

  public get title(): string {
    return this.text.substring(this.text.indexOf(':') + 1)
  }

  public get isObjective(): boolean {
    // Matches the current "Marketing Objectives:" prefix as well as the legacy
    // "Objective:" prefix. Note the plural new name does NOT contain the legacy
    // substring, so both must be checked explicitly.
    const lowerText = this.text.toLowerCase()
    return lowerText.indexOf('objective:') > -1 ||
      lowerText.indexOf('marketing objectives:') > -1
      ? true
      : false
  }

  public get isTargetSegment(): boolean {
    // Matches the current "Target Audience:" prefix as well as the legacy
    // "Target Segment:" / "Target Persona:" prefixes.
    const lowerText = this.text.toLowerCase()
    return lowerText.indexOf('target segment:') > -1 ||
      lowerText.indexOf('target persona:') > -1 ||
      lowerText.indexOf('target audience:') > -1
      ? true
      : false
  }

  public static fromResponseObject(obj): Tag {
    if (!obj) return new Tag()
    
    return new Tag(
      ID.fromResponseObject(obj.id, 'tags'),
      obj.text,
      ID.fromResponseObject(obj.plan, 'plans'),
      obj.isLead,
      obj.isNested,
      obj.orderIndex
    )
  }

  public forRequestObject() {
    return {
      id: this.id.intID == 0 ? null : this.id.apiID,
      text: this.text,
      plan: this.planId.intID == 0 ? null : this.planId.apiID,
      orderIndex: this.orderIndex,
    }
  }
}
